<template>
  <div class="additional-entrance">
    <div class="additional-entrance__header">
      <v-icon color="primary" class="additional-entrance__header-icon">mdi-door-plus</v-icon>
      <h2 class="additional-entrance__title">Создание дополнительного входа</h2>
    </div>
    <v-form ref="formEditDoorphone" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" sm="5" class="additional-entrance__form-col">
          <v-row>
            <v-col cols="12" sm="10" class="py-0 pt-2">
              <v-text-field
                v-model="formDoorphone.main_doorphone_id"
                label="Основной домофон"
                :rules="rules.requiredNumber"
                prepend-inner-icon="mdi-doorbell-video"
                type="number"
                outlined
                dense
                flat
                required
                disabled
                class="additional-entrance__field"
              />
            </v-col>
            <v-col cols="12" sm="10" class="py-0 pt-2">
              <v-text-field
                v-model="formDoorphone.main_address"
                label="Адрес"
                prepend-inner-icon="mdi-rename-box-outline"
                outlined
                dense
                flat
                required
                disabled
                class="additional-entrance__field"
              />
            </v-col>
            <v-col cols="12" sm="10" class="py-0 pt-2">
              <v-text-field
                v-model="formDoorphone.comment"
                label="Комментарий"
                prepend-inner-icon="mdi-comment-outline"
                type="text"
                outlined
                dense
                flat
                required
                class="additional-entrance__field"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pb-0">
          <v-card class="additional-entrance__card">
            <v-card-title class="additional-entrance__card-title">
              <span class="additional-entrance__card-title-text">Устройства</span>
              <v-spacer />
              <v-text-field
                v-model="searchDevice"
                label="Поиск по IP адресу"
                dense
                autocomplete="off"
                hide-details
                outlined
                class="additional-entrance__search-field"
                prepend-inner-icon="mdi-magnify"
                @keyup="(e) => e.keyCode === 13 && filterDevices()"
              />
              <v-btn
                color="primary"
                class="text-none ml-3"
                dark
                rounded
                @click.prevent="filterDevices"
              >
                <v-icon left small>mdi-magnify</v-icon>
                Поиск
              </v-btn>
            </v-card-title>
            <v-data-table
              class="table"
              v-model="selectedDevices"
              :options.sync="universalOptions"
              :server-items-length="universalTotalDevices"
              :headers="headersDevices"
              :items="devices"
              item-key="id"
              show-select
              :footer-props="{
                  'items-per-page-options': [10, 20, 50, 100],
                }"
              :single-select="true"
              :disable-sort="true"
            >
            </v-data-table>
          </v-card>
          <v-col cols="12" v-if="errorDevice">
            <v-alert type="error" dense outlined>
              Выберите устройство
            </v-alert>
          </v-col>
        </v-col>
      </v-row>
      <div class="additional-entrance__actions">
        <v-btn
          color="primary"
          class="text-none"
          dark
          rounded
          @click="validate()"
        >
          <v-icon left>mdi-plus</v-icon>
          Создать
        </v-btn>
        <v-btn
          color="primary"
          outlined
          rounded
          class="text-none ml-2"
          @click.prevent="returnDoorphone && returnDoorphone()"
        >
          <v-icon left>mdi-close</v-icon>
          Отменить
        </v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { rules, headersDevices } from '../consts';
import watchTableOptions from '../../../../mixins/watchTableOptions';

export default {
  name: 'AdditionalEntrance',
  props: ['returnDoorphone'],
  mixins: [watchTableOptions],
  data: () => {
    return {
      isFirstLoading: true,
      rules,
      errorDevice: false,
      selectedDevices: [],
      universalTotalDevices: 0,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      headersDevices,
      valid: true,
      searchDevice: '',
      filteredDevices: [],
      currentDevice: '',
      include: ['childDoorphones,parentDoorphones,additionalEntrances'],
      formDoorphone: {
        comment: '',
        main_doorphone_id: '',
        main_address: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      devices: 'Device/devices',
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
      roleName: 'roleName',
    }),
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
    searchCity (val) {
      if (!this.isFirstLoading) {
        val && val !== this.formDoorphone.city && this.loadCities({
          city_name: val,
          type: 'city',
        });
      }
    },
    searchStreet (val) {
      if (!this.isFirstLoading) {
        this.loadStreets({
          street_name: val,
          city_id: this.formDoorphone.city.city_id,
          type: 'street',
        });
      }
    },
    searchHouse (val) {
      if (!this.isFirstLoading) {
        this.loadHouses({
          house_name: val,
          street_id: this.formDoorphone.street.street_id,
          type: 'house',
        });
      }
    },
  },
  created () {
    const filters = ({
      free: 1,
      agent_id: this.doorphoneEditInfo.doorphone.agent_id,
    });
    if (this.doorphone.device_id) {
      if (this.doorphone.model) {
        filters['model.name'] = this.doorphone.model;
      }
    }
    this.loadDevices({
      pagination: 1,
      limit: this.universalOptions.itemsPerPage,
      filters,
    })
      .then((response) => {
        this.universalTotalDevices = response.meta.total;
      });
    const options = {
      include: this.include,
    };
    this.loadDoorphone({
      id: this.$route.params.id,
      options,
    })
      .then(() => {
        this.formDoorphone.main_doorphone_id = this.doorphoneEditInfo.doorphone.id;
        this.formDoorphone.main_address = this.doorphoneEditInfo.doorphone.address;
      });
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      loadDoorphone: 'Doorphone/getExpandedDoorphone',
      additionalDoorphone: 'Doorphone/additionalDoorphone',
    }),
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = ({
        free: 1,
        agent_id: this.doorphoneEditInfo.doorphone.agent_id,
      });

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка загрузки информации');
          }
        });
    },
    validate () {
      this.errorDevice = false;
      let tempDevice;
      if (!this.selectedDevices.length) {
        this.$flash_warning('Заполните все поля');
        this.errorDevice = true;
        return;
      } else {
        tempDevice = this.selectedDevices[0].id;
      }

      const tempDoorphone = {
        device_id: tempDevice,
        comment: this.formDoorphone.comment,
        main_doorphone_id: this.formDoorphone.main_doorphone_id,
        main_address: this.formDoorphone.main_address,
      };
      tempDoorphone.comment = this.formDoorphone.comment;
      this.additionalDoorphone(tempDoorphone)
        .then(() => {
          this.$router.push({ name: 'Doorphone' });
        }).catch(() => {
          this.$flash_warning('Ошибка при создании домофона');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.additional-entrance__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.additional-entrance__header-icon {
  flex-shrink: 0;
}

.additional-entrance__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.additional-entrance__form-col {
  padding-top: 16px;
}

.additional-entrance__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.additional-entrance__card {
  border-radius: 12px;
}

.additional-entrance__card-title {
  flex-wrap: wrap;
  gap: 12px;
}

.additional-entrance__card-title-text {
  margin-right: 12px;
}

.additional-entrance__search-field {
  max-width: 280px;
}

.additional-entrance__search-field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.additional-entrance__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 32px;
}

.edit-buttons button.v-btn {
  min-width: 270px;
}
</style>
